import React from 'react';
import { Button, Icon } from '@sabre/spark-react-core';
import { array, func, string } from 'prop-types';
import { CSVLink } from 'react-csv';

const NewFaresError = ({ data, title, fileName, onClose }) => {
   return (
      <div className='new-fares-error-root-view'>
         <div className='row spark-bold export-conform-text'>{title}</div>
         <div className='row spark-flex spark-pad-t-2 justify-end'>
            <CSVLink filename={fileName} data={data} onClick={() => onClose()}>
               <Icon
                  name='file-download'
                  className='spark-pad-t-.5 spark-mar-r-2 cursor-pointer'
                  size='md'
                  style='fill'
                  label='Download Icon'
               />
            </CSVLink>
            <Button
               name='Cancel button'
               className='spark-btn--secondary spark-mar-r-1'
               size={Button.SIZE.SMALL}
               onClick={onClose}
            >
               CANCEL
            </Button>
         </div>
      </div>
   );
};
NewFaresError.propTypes = {
   data: array,
   onClose: func,
   title: string,
   fileName: string,
};

export default NewFaresError;
